import Footer from "../components/Footer";
import "./style.css";
import { useNavigate } from "react-router-dom";
import LanImg_1 from "../assets/img/Languageimg_1.png";
import LanImg_2 from "../assets/img/Languageimg_2.png";
const Frame = (props) => {
  return (
    <div className="frame">
      <div className="div-2">
        <div className="text-wrapper-2">{props.header1}</div>

        <div className="text-wrapper-3">{props.header2}</div>
      </div>

      <p className="language-frame-p">{props.desc}</p>
    </div>
  );
};

const Group = () => {
  return (
    <div
      className="flex flex-col items-center  
             md:flex-row md:items-center md:justify-between md:gap-6 w-full mt-10"
    >
      <div className="flex flex-col items-center mb-4">
        <div className="text-3xl font-semibold">99.5%</div>
        <div className="opacity-80">Visa approved</div>
      </div>

      <img
        className="hidden md:block h-8"
        src="https://c.animaapp.com/HwA6Ml4A/img/vector-24.svg"
        alt="vector"
      />

      <div className="flex flex-col items-center mb-4">
        <div className="text-3xl font-semibold">10000+</div>
        <div className="opacity-80">Students Guided</div>
      </div>

      <img
        className="hidden md:block h-8"
        src="https://c.animaapp.com/HwA6Ml4A/img/vector-25.svg"
        alt="vector"
      />

      <div className="flex flex-col items-center mb-4">
        <div className="text-3xl font-semibold">100%</div>
        <div className="opacity-80">Student satisfaction</div>
      </div>

      <img
        className="hidden md:block h-8"
        src="https://c.animaapp.com/HwA6Ml4A/img/vector-26.svg"
        alt="vector"
      />

      <div className="flex flex-col items-center mb-4">
        <div className="text-3xl font-semibold">2021</div>
        <div className="opacity-80">Established</div>
      </div>
    </div>
  );
};


const Container = () => {
  return (
    <div style={{ padding: "3% 0%" }} className="container">
      <p className="text-wrapper-12">English Proficiency Tests for <br />Global Students</p>

      <p className="from-initial">
        Knowing the structure, scoring pattern, and eligibility criteria of different English exams helps you select the
        <br />
        one that best fits your study abroad goals.
      </p>
    </div>
  );
};


export default function LanguagePrep() {
  const navigate = useNavigate();
  const language = [
    {
      route: "/password-english-language-test",
      title: "Password English Language Test",
      desc: "The Password Skills Plus Test is an online English assessment designed for international students seeking admission to universities abroad. It measures key language skills required for academic success.",
    },
    {
      route: "/language-cert",
      title: "LanguageCert",
      desc: "  LanguageCert is a flexible English proficiency test offered in multiple levels. Candidates can take it either online from home or at a test centre, and it is accepted by more than 2,500 institutions across 100+ countries.",
    },
    {
      route: "/toefl",
      title: "TOEFL",
      desc: "The Test of English as a Foreign Language (TOEFL) evaluates your ability to use and understand academic English. It is recognized and accepted by most universities and institutions around the globe.",
    },
    {
      route: "/doulingo",
      title: "Duolingo",
      desc: " The Duolingo English Test is a completely online language proficiency exam that can be completed in about an hour. It’s recognized by more than 5,500 universities and institutions around the world.",
    },
    {
      route: "/pte",
      title: "PTE",
      desc: " The Pearson Test of English (PTE) is a fully computer-based exam popular among students applying to global universities. Its AI-powered scoring system provides reliable results, typically available within 48 hours, making it one of the fastest testing options.",
    },
    {
      route: "/ielts",
      title: "IELTS",
      desc: " The International English Language Testing System (IELTS) is one of the most widely accepted tests for proving English proficiency. It’s offered in two formats — Academic and General Training — to suit different study or migration needs.",
    },
  ];

  return (
    <div className="language">
      <div >
        <section className=" pt-2 pb-0 text-center md:hidden">
          <h2 className="text-[28px] font-semibold text-[#051d62] leading-tight">
            Your gateway to <br />
            <span className="text-blue-700">Global Education</span>
          </h2>

          <p className="p-2 mt-4 text-gray-600 text-[14px] leading-relaxed">
            Qualify for admission to your preferred university by taking an
            English language proficiency test with expert support from Global StudyIn.
          </p>

          <img
            className="w-full mt-4 rounded-lg"
            src={LanImg_1}
            alt="Students"
          />
        </section>

        {/* DESKTOP HERO + TEXT */}
        <div className="hidden md:block">
          <div className="services-rectangle">
            <div className="frame">
              <div className="service-div-2">
                <div className="service-text-wrapper-2">Your gateway to</div>

                <div className="service-text-wrapper-3">Global Education</div>
              </div>

              <p className="p">
                Qualify for admission to your preferred university by taking an
                English language proficiency test with expert support from Global
                StudyIn.
              </p>
            </div>

            <img
              className="services-rectangle-2"
              alt="Rectangle"
              src={LanImg_1}
            />
          </div>
        </div>

      </div>
      <div className="language-container-background" style={{ padding: "0% 7%" }}>
        <Group />

        <div
          className="language-section-image-text "
          style={{ paddingTop: "50px" }}
        >
          <img
            className="language-rectangle-2"
            alt="Rectangle"
            src={LanImg_2}
          />

          <Frame
            header1={"Why English Proficiency Tests"}
            header2={" Matter for Studying Abroad"}
            desc={` Most universities require international students to demonstrate English language proficiency to ensure they can follow lectures, engage in coursework, and complete their studies successfully. Recognized tests such as IELTS and PTE serve as official proof of language ability.
        Global StudyIn’s English training programs provide one-on-one guidance to
            help you improve your skills and achieve the score needed for
            admission to your chosen university.`}
          />
        </div>

        <Container />

        <section className=" py-16 bg-white">
          <div className="grid md:grid-cols-3 gap-8">
            {language.map((svc, idx) => (
              <div
                key={idx}
                className="language-card-container p-6 border rounded-lg shadow hover:shadow-lg"
              >
                <div className="card-text-container">
                  <h3 className="card-text-wrapper font-semibold text-lg mb-3">
                    {svc.title}
                  </h3>
                  <p className="card-text-desc text-gray-600 mb-3">
                    {svc.desc}
                  </p>
                </div>
                <button onClick={() => navigate(svc.route)} className="card-btn card-btn-text text-white-700 font-medium">
                  Learn more
                </button>
              </div>
            ))}
          </div>
        </section>
      </div>

      <div className="language-prep-footer">
        <Footer />
      </div>
    </div>
  );
}
